document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery) return;
  var sortWidth = $("#sort-by").width();
  var optionWidth = $("#sort-by option").filter(":selected").text();
  if (optionWidth == "Featured") {
    $("#sort-by").width("7em");
  } else if (
    optionWidth == "Price: Low to High" ||
    optionWidth == "Price: High to Low"
  ) {
    $("#sort-by").width("13em");
  } else if (optionWidth == "A-Z" || optionWidth == "Z-A") {
    $("#sort-by").width("2.5em");
  } else if (
    optionWidth == "Date, old to new" ||
    optionWidth == "Date, new to old"
  ) {
    $("#sort-by").width("12em");
  } else if (optionWidth == "Best Selling") {
    $("#sort-by").width("9em");
  }

  $("#sort-by").bind("change", function () {
    $("#width_tmp_option").html($("#sort-by option:selected").text());
    $(this).width($("#width_tmp_select").width());
    ``;
  });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
});

const sortSelect = document.getElementById('sort-by');

sortSelect.addEventListener('change', (evt) => {
  const currentUrl = new URL(location.href)
  currentUrl.searchParams.set('sort_by', evt.target.value)
  currentUrl.searchParams.delete('page')

  window.location = currentUrl

})
